var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-5"},[_c('strong',{staticClass:"text-h3 grey--text"},[_vm._v(_vm._s(_vm.$t('construction')))])])}
var staticRenderFns = []

export { render, staticRenderFns }